import Repacking from '@/models/Repacking/Repacking';

export default class RepackingFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.repackingNo = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.repackDateFrom = '';
		this.repackDateTo = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.repackStatusId  = '';
		this.repackStatusName = '';
		this.repackById  = '';
		this.repackByFirstName = '';
		this.startDateFrom = '';
		this.startDateTo = '';
		this.finishDateFrom = '';
		this.finishDateTo = '';
		this.poNoCustomer = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			repackingNo : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			repackDateFrom : '0',
			repackDateTo : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			repackStatusId : '0',
			repackStatusName : '0',
			repackById : '0',
			repackByFirstName : '0',
			startDateFrom : '0',
			startDateTo : '0',
			finishDateFrom : '0',
			finishDateTo : '0',
			poNoCustomer : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}